// How far the player dragged the card that rests on the log, from its place
// of rest. The wide layout only. The next card rests where the last one was put.

import { createStore } from '../lib/store';

export type CardOffset = { x: number; y: number };

const AT_REST: CardOffset = { x: 0, y: 0 };

export const cardRestStore = createStore<CardOffset>(AT_REST);

export const moveRestingCard = (offset: CardOffset): void => cardRestStore.set(offset);
